export function todayKey() {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${now.getFullYear()}-${month}-${day}`;
}

export function addDays(dateKey, days) {
  const date = new Date(`${dateKey || todayKey()}T00:00:00.000Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function getWeekDays(dateKey) {
  const selected = new Date(`${dateKey || todayKey()}T00:00:00.000Z`);
  const day = selected.getUTCDay();
  const start = addDays(selected.toISOString().slice(0, 10), -day);

  return Array.from({ length: 7 }, (_, index) => {
    const key = addDays(start, index);
    const date = new Date(`${key}T00:00:00.000Z`);
    return {
      key,
      weekday: date.toLocaleDateString("en-IN", {
        weekday: "short",
        timeZone: "UTC",
      }),
      day: date.getUTCDate(),
    };
  });
}

export function formatTaskDate(dateKey) {
  if (!dateKey) return "";
  const date = new Date(`${dateKey}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime())) return dateKey;

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function formatTaskMonth(dateKey) {
  const date = new Date(`${dateKey || todayKey()}T00:00:00.000Z`);
  return date.toLocaleDateString("en-IN", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function formatTaskLabel(value) {
  return String(value || "")
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part[0].toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");
}

export function splitEstimatedMinutes(minutes = 60) {
  const safeMinutes = Math.max(1, Number(minutes || 60));
  return {
    estimatedHours: String(Math.floor(safeMinutes / 60)),
    estimatedExtraMinutes: String(safeMinutes % 60),
  };
}

export function buildTaskForm(task = {}, dateKey = todayKey()) {
  const estimate = splitEstimatedMinutes(task.estimatedMinutes || 60);

  return {
    title: task.title || "",
    details: task.details || "",
    project: task.project || "General",
    dueDate: task.dueDate || dateKey,
    priority: task.priority || "medium",
    assignedTo: task.assignedTo?.user || task.assignedTo?._id || "",
    estimatedHours: estimate.estimatedHours,
    estimatedExtraMinutes: estimate.estimatedExtraMinutes,
  };
}

export function matchesTaskSearch(task, searchText) {
  const needle = String(searchText || "").trim().toLowerCase();
  if (!needle) return true;

  return [
    task.title,
    task.details,
    task.project,
    task.priority,
    task.effectiveStatus,
    task.assignedBy?.fullName,
    task.assignedTo?.fullName,
  ]
    .join(" ")
    .toLowerCase()
    .includes(needle);
}
